import {clsx, type ClassValue} from "clsx"
import {twMerge} from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export const htmlDecode = (input: string) => {
    var doc = new DOMParser().parseFromString(input, "text/html")
    return doc.documentElement.textContent
}

const IS_DEV = process.env.NODE_ENV === "development"

export const devLog = (...args: any[]) => {
    if (IS_DEV) {
        console.log(...args)
    }
}

export const formatPrice = (price: number): string => {
    // Check if the number is an integer
    if (Number.isInteger(price)) {
        return price.toString()
    }
    // Number has a decimal part, format to two decimal places
    return price.toFixed(2)
}
